<template>
    <div class="card-service">
        <div class="card-service__header d-flex align-items-start justify-content-between">
            <img :src="item.icon" alt="icon"> <h6 v-if="item.category" :class="{'green': item.green}">{{item.category}}</h6>
        </div>
        <div class="card-service__excerpt">
            <h6>{{ item.excerpt }}</h6>
        </div>
        <div class="card-service__title mb-1">
            <h3>{{ item.title }}</h3>
        </div>
        <div class="card-service__text" v-html="item.text">
        </div>
        <a :href="item.url" class="card-service__url"></a>
    </div>
</template>

<script>
export default {
    name: 'CardService',
    props: {
        'item': {
            type: Object,
            default: null,
        }
    }
}
</script>
